import { getPushCategoryEventHandler } from './AnalyticsGAHelpers';

const CATEGORY = 'authentication_events';

enum Actions {
  AUTH_STARTED = 'auth_started'
}

const push = getPushCategoryEventHandler<Actions>(CATEGORY);

// Events

// --- Authentication Started

export function authStarted() {
  return push(Actions.AUTH_STARTED);
}
